import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import InnerHeader from "../InnerHeader/InnerHeader";
import Input from "../Input/Input";
import ThemeBtn from "../ThemeBtn/ThemeBtn";
import { register } from "../../api/LoginService";
import FetchService from "../../api/FetchService";
import LoadingOverlay from "react-loading-overlay";

import "./AddPartner.scss";

//userTypeID = 1 because its for customers
//Todo: edit this object model
let partner = {
    firstname: "",
    lastname: "",
    address: "",
    email: "",
    password: "",
    confirmpassword: "",
    phone: "",

};

function PartnersPageBusiness() {
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [address, setAddress] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");

  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
    const targetRef = useRef(null);



  const [isLoading, setIsLoading] = useState(false);
    const [response, setResponse] = useState("");

    // Invoice-related fields
    const [companyName, setcompanyName] = useState('');
    const [organizationNumber, setorganizationNumber] = useState('');
    const [invoiceAddress, setinvoiceAddress] = useState('');
    const [invoiceSentTo, setinvoiceSentTo] = useState('');
    const [contactPerson, setcontactPerson] = useState('');
    const [invoiceNote, setinvoiceNote] = useState('');

    const [showInvoice, setshowInvoice] = useState(false);



    const scrollToDiv = () => {
        targetRef.current.scrollIntoView({
            behavior: 'smooth', // Optional: smooth scrolling behavior
            block: 'start' // Optional: scroll to the top of the element
        });
    };

    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setResponse("");

        // Check if all required fields are filled
        if (!firstname || !lastname || !address || !phone || !email || !password || !confirmpassword) {
            setIsLoading(false);
            setResponse("AllFieldsRequired");
            return;
        }

        // If invoice section is visible, check required fields
        if (showInvoice && (!companyName || !organizationNumber || !invoiceAddress || !invoiceSentTo || !contactPerson || !invoiceNote)) {
            setIsLoading(false);
            setResponse("InvoiceFieldsRequired");
            return;
        }

        // Password validation
        if (password.length > 0 && password !== confirmpassword) {
            setIsLoading(false);
            setResponse("FailedPassword");
            return;
        }

        // Create partner object
        const partnerData = {
            firstname,
            lastname,
            address,
            phone,
            email,
            password,
            confirmpassword,
            partnerSince: new Date().toJSON().slice(0, 10).replace(/-/g, "/"),
        };

        // Add invoice details if applicable
        if (showInvoice) {
            partnerData.invoiceDetails = {
                companyName,
                organizationNumber,
                invoiceAddress,
                invoiceSentTo,
                contactPerson,
                invoiceNote,
            };
        }

        try {
            const response = await FetchService.AddCompany(partnerData);

            if (response?.data > 1) {
                setResponse("Success");
                clearForm();
            } else {
                setResponse("Failed");
            }
        } catch (error) {
            console.error("Error adding company:", error);
            setResponse("Error");
        } finally {
            setIsLoading(false);
        }
    };

    // Function to clear form
    function clearForm() {
        setFirstName("");
        setLastName("");
        setAddress("");
        setPhone("");
        setPassword("");
        setConfirmPassword("");
        setEmail("");
        setcompanyName("");
        setorganizationNumber("");
        setinvoiceAddress("");
        setinvoiceSentTo("");
        setcontactPerson("");
        setinvoiceNote("");
        setshowInvoice(false);
        setIsLoading(false);
    }

    // Function to check if all required fields are filled
    function isFormValid() {
        const personalFieldsFilled = [firstname, lastname, address, phone, password, confirmpassword, email].every(field => field.trim() !== "");
        const isFakturaValid = !showInvoice ||
            [companyName, organizationNumber, invoiceAddress, invoiceSentTo, contactPerson, invoiceNote]
                .every(field => field && field.trim() !== "");

        return personalFieldsFilled && isFakturaValid;
    }


  return (
    <LoadingOverlay
      active={isLoading}
      spinner
      text="Behandler forespørselen din"
    >
      <div className="Register_page">
              <section className="add_partner_main data-grid">
          <InnerHeader HeaderHeading="Add Partner" PageText="Add Partner" />
          <div className="container">
            <div className="row row_custom ">
              <div className=" ">
                              <div className="" ref={targetRef}>
                                  <h2 class="form_heading inner_header_main">Legg til bedriftskunde</h2>
           
                  {response === "Failed" && (
                    <div className="error_message">
                                          {"Feil: Bedriftskunde ikke registrert. Prøv igjen."}
                    </div>
                                  )}
                                  {response === "FailedPassword" && (
                                      <div className="error_message">
                                          {"Feil: Bedriftskundepassordet samsvarer ikke."}
                                      </div>
                                  )}

                                  
                  {response === "Success" && (
                    <div className="success_message">
                                          {"Bedriftskunde registrert"}
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className="form_main">
                    <div className="Input_otr">
                      <Input
                        InputClass="Theme_input_white form_input"
                        Inputype="text"
                        InputName="First name"
                        label="Fornavn"
                        value={firstname}
                        required
                        onChange={(event) => setFirstName(event.target.value)}
                      />

                    </div>
                    <div className="Input_otr">
                        <Input
                            InputClass="Theme_input_white form_input"
                            Inputype="text"
                            InputName="Last name"
                            label="Etternavn"
                                              value={lastname}
                                              required
                            onChange={(event) => setLastName(event.target.value)}
                        />
                    </div>

                    <div className="Input_otr">
                      <Input
                        InputClass="Theme_input_white form_input"
                        Inputype="text"
                        InputName="address"
                        label="Adresse"
                        value={address}
                        required
                        onChange={(event) => setAddress(event.target.value)}
                      />
                    </div>


                    <div className="Input_otr">
                      <Input
                        InputClass="Theme_input_white form_input"
                        label="Email"
                        value={email}
                        required
                        onChange={(event) => setEmail(event.target.value)}
                      />
                    </div>

                    <div className="Input_otr">
                      <Input
                        InputClass="Theme_input_white form_input"
                        Inputype="password"
                        InputName="Password"
                        label="Passord"
                        required
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                      />
                    </div>


                    <div className="Input_otr">
                        <Input
                            InputClass="Theme_input_white form_input"
                            Inputype="password"
                            InputName="Confirm passord"
                            label="bekreft passord"
                            required
                            value={confirmpassword}
                            onChange={(event) => setConfirmPassword(event.target.value)}
                        />
                    </div>


                    <div className="Input_otr">
                        <Input
                            InputClass="Theme_input_white form_input"
                            Inputype="number"
                            InputName="phone"
                            label="Telefonnummer"
                                              value={phone}
                            required
                            onChange={(event) => setPhone(event.target.value)}
                        />
                    </div>

                                      <div>
                                          <label>Ønsker du å legge til fakturainformasjon?</label>
                                          <div>
                                              
                                              <label class="padding-18" htmlFor="fakturaJa">
                                                  <input
                                                      type="radio"
                                                      id="fakturaJa"
                                                      name="faktura"
                                                      checked={showInvoice === true}
                                                      value="true" // Ensure it's a string
                                                      onChange={() => setshowInvoice(true)}
                                                  />
                                                  Ja</label>
                                         
                                              <label class="padding-18" htmlFor="fakturaNei">
                                                  <input
                                                      type="radio"
                                                      id="fakturaNei"
                                                      name="faktura"
                                                      value="false" // Ensure it's a string
                                                      checked={showInvoice === false}
                                                      onChange={() => setshowInvoice(false)}
                                                  />
                                                  Nei</label>
                                          </div>

                                      </div>


                                      {showInvoice && (
                                          <div className="invoice-section">
                                              <h4 className="mx-4 text-center fw-bold m-2" >FAKTURA INFORMASJON</h4>
                                              <div className="form-group">
                                                  <div class="row  d-flex justify-content-center align-items-end" >
                                                      <div class=" my-3 col-md-6">
                                                          <div >

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="label_input heading-xs required">Bedriftsnavn:</h6>
                                                                  <input
                                                                      tabindex="2"
                                                                      required
                                                                      type="text"
                                                                      name="companyName"
                                                                      value={companyName}
                                                                      onChange={(event) => setcompanyName(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="label_input heading-xs required">Org nr:</h6>
                                                                  <input
                                                                      tabindex="4"
                                                                      required
                                                                      type="text"
                                                                      name="organizationNumber"
                                                                      value={organizationNumber}
                                                                      onChange={(event) => setorganizationNumber(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="required label_input heading-xs">Faktura adresse:</h6>
                                                                  <input
                                                                      tabindex="6"
                                                                      required
                                                                      type="text"
                                                                      name="invoiceAddress"
                                                                      value={invoiceAddress}
                                                                      onChange={(event) => setinvoiceAddress(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>
                                                          </div>
                                                      </div>

                                                      <div class="label_input heading-xs my-3 col-md-6">
                                                          <div >

                                                              <div class="input-container Input_otr">
                                                                  <h6 class=" required">Faktura sendes til:</h6>
                                                                  <input
                                                                      required
                                                                      tabindex="3"
                                                                      type="text"
                                                                      name="invoiceSentTo"
                                                                      value={invoiceSentTo}
                                                                      onChange={(event) => setinvoiceSentTo(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="required label_input heading-xs">Kontaktperson:</h6>
                                                                  <input
                                                                      required
                                                                      tabindex="5"
                                                                      type="text"
                                                                      name="contactPerson"
                                                                      value={contactPerson}
                                                                      onChange={(event) => setcontactPerson(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="required label_input heading-xs">Faktura merkes med:</h6>
                                                                  <input
                                                                      required
                                                                      tabindex="7"
                                                                      type="text"
                                                                      name="invoiceNote"
                                                                      value={invoiceNote}
                                                                      onChange={(event) => setinvoiceNote(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                      rows="4"
                                                                  />
                                                              </div>

                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>

                                          </div>
                                      )}

                    <div className="Input_otr action_otr">
                      <button
                        disabled={!isFormValid()}
                        type="submit"
                        className="Theme_btn_primary form_btn"
                      >
                        Legg til
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </LoadingOverlay>
  );
}

export default PartnersPageBusiness;
